<template>
  <div>
    <printSheet>
      <div slot='printContent' id="batchPrintBill2" ref="batchPrintBill2" style="width: 900px;">
        <div v-for="(item, index) in list" :key="index">
            <h2 style="display: flex;justify-content: center;">{{`${item.storeName || ''}\xa0\xa0零售出库单`}}</h2>
            <div>客户名称：{{item.patientName || ''}}</div>
            <div style="display: flex;justify-content: space-between;">
                <div>公司地址：{{formatAdress($store.state.storeInfo.detailAddress) || ''}}</div>
                <div>出库日期：{{exchangeTimeToDate(item.createTime,true)}}</div>
            </div>
            <table border="1" cellpadding="0" cellspacing="0" style="width:100%; text-align: center;">
                <tr>
                    <td style="width: 10%">货号</td>
                    <td style="width: 10%">{{item.drugSerialCode || ''}}</td>
                    <td style="width: 10%">品名</td>
                    <td colspan="3">{{`${item.approvedDrugNames}${item.goodsName ? `(${item.goodsName})` : ''}`}}</td>
                    <td>规格</td>
                    <td colspan="3">{{item.specifications || ''}}</td>
                </tr>
                <tr>
                    <td>单位</td>
                    <td>{{item.goodsUnit || ''}}</td>
                    <td>生产企业</td>
                    <td colspan="3">{{item.manufacturer || ''}}</td>
                    <td>批准文号</td>
                    <td colspan="3">{{item.approvalCode || ''}}</td>
                </tr>
                <tr>
                    <td>储藏条件</td>
                    <td>{{item.storageCondition || ''}}</td>
                    <td>剂型</td>
                    <td colspan="7">{{item.dosageForm || ''}}</td>
                </tr>
                <tr>
                    <td>生产批号</td>
                    <td>{{item.goodsLot || ''}}</td>
                    <td>生产日期</td>
                    <td style="width: 10%">{{exchangeTimeToDate(item.manufactureDate)}}</td>
                    <td style="width: 10%">有效期至</td>
                    <td style="width: 10%">{{exchangeTimeToDate(item.expireDate)}}</td>
                    <td style="width: 10%">销价</td>
                    <td style="width: 10%">{{numFormat(item.realPrice) || ''}}</td>
                    <td style="width: 10%">数量</td>
                    <td style="width: 10%">{{item.goodsCount || ''}}</td>
                </tr>
                <tr>
                    <td colspan="2"></td>
                    <td>折扣金额</td>
                    <td colspan="3">{{numFormat(item.discountDisplay)}}</td>
                    <td>合计金额</td>
                    <td colspan="3">{{numFormat(item.amountWithoutDiscountDisplay)}}</td>
                </tr>
            </table>
            <div>大写金额：{{exchangeNumToChinese(item.amountWithoutDiscountDisplay)}}</div>
            <p class="page-break"></p>
        </div>
      </div>
    </printSheet>
  </div>
</template>
<script>
import printSheet from '../printSheet.vue';
import utils from '../../libs/utils';

export default {
  name: 'batchPrintBillStyleTwo',
  components: {
    printSheet,
  },
  props: {
    printData: [],
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    numFormat(num) {
      const res = num.toString().replace(/\d+/, n => n.replace(/(\d)(?=(\d{3})+$)/g, $1 => `${$1},`));
      return res;
    },
    formatAdress(adress) {
      if (!adress) {
        return '';
      }
      let str = adress.replace('/县', '');
      str = str.replace(/\//g, '');
      str = str.replace('市辖区', '');
      return str;
    },
    exchangeTimeToDate(time, chineseForm) {
      if (time) {
        if (chineseForm) {
          const date = new Date(time);
          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          const day = date.getDate();
          return `${year}年${month}月${day}日`;
        }
        return utils.formatDate(time);
      }
      return '';
    },
    exchangeNumToChinese(n) {
      return utils.exchangeNumToChinese(n);
    },
    print() {
      const data = [];
      this.printData.forEach((item) => {
        item.saleOrderDetailList.forEach((child) => {
          if (item.salePrescription) {
            child.patientName = item.salePrescription.patientName || '';
          }
        });
        if (item.saleOrderDetailList && item.saleOrderDetailList.length > 0) {
          data.push(...item.saleOrderDetailList);
        }
      });
      this.list = data;
      this.$nextTick(() => {
        this.$print(this.$refs.batchPrintBill2);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.page-break {
  page-break-after: always;
}
div {
  font-size: 18px;
}
</style>
